import { SET_BRANCHENBUCH_SEARCH } from './branchenbuchSearch.types';
export var setBranchenbuchSearch = function setBranchenbuchSearch(isBranchenbuchSearch) {
  return {
    type: SET_BRANCHENBUCH_SEARCH,
    branchenbuchSearch: {
      isBranchenbuchSearch: isBranchenbuchSearch
    }
  };
};